import React, { useState } from 'react';
import { Divider, Descriptions, Row, Col, Modal, Button, Icon, Table, Tooltip } from 'antd';
import { maths, network, generators } from '../../../utils';
import InputNum from '../InputNum';
import api from '../../../config/api';
import { download } from '../../../utils/biz';
import { formatToFixed } from '../../../utils/biz';
import { message } from '../../../components/biz';
import './index.less';

const { add, mul, div } = maths;
const { formatToFixed2 } = formatToFixed;

const { Column } = Table;

export default ({ visible, onCancel, quotaionDataSource }) => {
  const [dataSource, setDataSource] = useState(quotaionDataSource.details); //明细行
  const handleCancel = () => {
    onCancel();
  };

  const handleDownload = async () => {
    const params = {
      ...quotaionDataSource,
      details: dataSource,
    };
    const response = await network({
      url: api.quotation.download,
      method: 'post',
      data: params,
      responseType: 'arraybuffer',
    });
    if (response.success) {
      const disposition = response.headers['content-disposition'] || '';
      const filename = quotaionDataSource.docName
        ? quotaionDataSource.docName
        : disposition.split('filename=')[1] || '';
      onCancel();
      download(response, decodeURI(filename) || '报价单.xls');
    } else {
      message.error(response.message);
    }
  };

  const handleSave = async () => {
    const response = await network.post(api.quotation.save, dataSource);
    if (response.success) {
      if (response.data.success) {
        onCancel();
      } else {
        message.error(generators.generatorObject(response.data).message);
      }
    }
  };

  const handleQuanChange = (value, record) => {
    if (!Number(value)) {
      value = 1;
    }
    setDataSource((preList) => {
      const newList = preList.map((pre) => {
        if (pre.lineNo === record.lineNo) {
          return {
            ...pre,
            pcs: value,
            lineAmt: +formatToFixed2(mul(div(record.teuncs, 1000), value)),
          };
        }
        return pre;
      });
      newList[newList.length - 1].lineAmt = calcTotalPrice(newList);
      return newList;
    });
  };

  const handleDelete = (record) => {
    setDataSource((preList) => {
      const newList = preList
        .map((pre) => {
          if (pre.lineNo === record.lineNo) {
            return null;
          }
          return pre;
        })
        .filter(Boolean);
      newList[newList.length - 1].lineAmt = calcTotalPrice(newList);
      return newList;
    });
  };

  const calcTotalPrice = (datas) => {
    const totalAmt = datas.reduce((total, record) => {
      if (record.lineNo !== '合计') {
        total = add(total, record.lineAmt);
      }
      return total;
    }, 0);
    return totalAmt;
  };
  const renderTemplate = () => {
    return (
      <div>
        <div className="modal-header">
          {/* <p className="header-tel">电话+86-15810850525</p>
          <p className="header-addr">北京市大兴区采育镇育镇街32号恒盛波尔多南区3号楼1蹭11底商</p> */}
          <img
            style={{ width: '100%' }}
            src={`${process.env.TARGET}static/imgs/quotation/quotation-preview-title.png`}
            alt=""
          />
        </div>
        <Divider />
        <div className="modal-title">
          <p>{quotaionDataSource.title}</p>
          <p style={{ letterSpacing: '10px' }}>报价单</p>
        </div>
        <Divider />
        <div className="modal-description">
          <Descriptions column={2}>
            <Descriptions.Item label="客户名"></Descriptions.Item>
            <Descriptions.Item label="供方联系人">{quotaionDataSource.contact}</Descriptions.Item>
            <Descriptions.Item label="联系人"></Descriptions.Item>
            <Descriptions.Item label="供方联系电话">{quotaionDataSource.mobile}</Descriptions.Item>
          </Descriptions>
        </div>
        <div className="modal-content">
          <p>
            感谢贵司的询价，兹报价如下，请及时审核，尽快回复！
            <span style={{ color: 'red' }}>数量调整，增值服务不再单独计算，请以实际下单为准</span>
          </p>
          <Table rowKey="lineNo" dataSource={dataSource} pagination={false} size="small">
            <Column title="序号" dataIndex="lineNo" width={60} />
            <Column title="材质" dataIndex="ibsrp3Dl01" width={60} />
            <Column title="标准" dataIndex="ibsrp7Dl01" />
            <Column title="品名" dataIndex="imdsc2AndIbsrp9Desc" width={120} />
            <Column title="规格" dataIndex="imdsc1" />
            <Column title="千支价" dataIndex="teuncs" />
            <Column
              title="数量"
              dataIndex="pcs"
              width={120}
              render={(value, record) => {
                if (record.lineNo === '合计') {
                  return value;
                }
                return (
                  <Tooltip visible={value === ''} title="请输入数量">
                    {' '}
                    <InputNum
                      placeholder="0"
                      value={value}
                      style={{ width: 60, padding: 4 }}
                      maxLength={8}
                      onChange={(value) => handleQuanChange(value, record)}
                    />
                  </Tooltip>
                );
              }}
            />
            <Column title="总金额" dataIndex="lineAmt" width={70} />
            <Column title="包装方式" dataIndex="packMethod" width={120} />
            <Column title="增值服务" dataIndex="reprocessOperationDesc" width={120} />
            <Column title="增值服务费" dataIndex="optProcPricesSum" width={90} />
            <Column title="短项目号" dataIndex="remark" width={90} />
            <Column title="备注" dataIndex="remark2" />
            <Column
              title="操作"
              width={60}
              render={(text, record) => {
                if (record.lineNo === '合计') {
                  return text;
                }
                return (
                  <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => handleDelete(record)}
                  >
                    删除
                  </span>
                );
              }}
            />
          </Table>
        </div>
        <div className="modal-footer">
          <Row className="footerRow">
            <Col span={2} style={{ textAlign: 'right' }}>
              备注：
            </Col>
            <Col span={14}>1. 此报价含13%增值税，含___至___的运费。</Col>
            <Col span={8}>{quotaionDataSource.title}</Col>
          </Row>
          <Row className="footerRow">
            <Col span={14} offset={2}>
              2. 报价有效期为___天，此价针对整单价格，如量减则价变。
            </Col>
            <Col span={8}>供方地址：{quotaionDataSource.address}</Col>
          </Row>
          <Row className="footerRow">
            <Col span={14} offset={2}>
              3. 此报价约定的结款方式：________。
            </Col>
            <Col span={8}>报价日期：{quotaionDataSource.createDate}</Col>
          </Row>
          <Row className="footerRow">
            <Col span={14} offset={2}>
              4. 库存现货产品默认最小包装整包装出货，指定包装或拆散或其他增值服务需收取相应费用。
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  return (
    <Modal
      title={
        <span>
          <Icon type="read" /> 报价单预览
        </span>
      }
      width="90%"
      visible={visible}
      className="quotationtemplateModal"
      onCancel={handleCancel}
      maskClosable={false}
      footer={
        <Row>
          <Button onClick={handleCancel}>取消</Button>
          {/* <Button type="btn-info" onClick={handleSave}>保存到个人中心</Button> */}
          <Button type="btn-info" onClick={handleDownload}>
            下载并保存本地
          </Button>
          <span style={{ marginLeft: 10 }}>下载后会自动保存到个人中心-》历史报价单</span>
        </Row>
      }
    >
      {renderTemplate()}
    </Modal>
  );
};
